// extracted by mini-css-extract-plugin
export default {"button_link":"link-button_button_link__1F+Be"};